import BookCalculatorAttributesStore from 'book-calculator/stores/BookCalculatorAttributesStore';
import BookCalculatorAmountStore from 'book-calculator/stores/BookCalculatorAmountStore';
import EmailSubscriptionService from '@99designs/common/utils/platform/emailSubscriptionService';

export function submit(ctx, { email }) {
    const attributes = ctx.getStore(BookCalculatorAttributesStore).getState();
    const amounts = ctx.getStore(BookCalculatorAmountStore).getAmounts();
    const service = new EmailSubscriptionService(window.analytics);

    return service
        .subscribe({
            email: email,
            acquisitionSource: 'book-calculator',
            customData: { amounts, attributes },
            subscribeToMarketing: true,
        })
        .catch(e => console.log('failed to subscribe email address', e));
}
